<template>
<div id="secure">

    <section class="main-content columns is-fullheight">
        <SideMenu />
        <div class="container column is-9">
            <div class="section">
                <a class="button is-info is-outlined" v-on:click="goTutorial()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-youtube-play"></i></span> Tutorial
                </a>
                <a class="button is-info is-outlined" v-on:click="getHelp()" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-question-circle"></i></span> Help
                </a>
                <a class="button is-info" href="https://www.studentqr.com/download" target="_blank" style="margin-top:-10px; margin-bottom: 5px;">
                    <span class="icon navbar-icon"><i class="fa fa-cloud-download"></i></span> Download App
                </a>
                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Add New Class</p>
                    </div>
                    <div class="card-content">
                        <div class="content"><data-create></data-create></div>
                    </div>
                </div>
                <br />

                <div class="card is-hidden1">
                    <div class="card-header">
                        <p class="card-header-title">Classes</p>
                    </div>
                    <div class="card-content">
                        <loading :active.sync="isLoading" 
                            :can-cancel="false" 
                            :is-full-page="true">
                        </loading>
                        <div class="content"><data-list v-bind:dataList="dataList"></data-list></div>
                    </div>
                </div>
                <br />

            </div>
        </div>
    </section>
</div>
</template>

<script>
import SideMenu from '../../SideMenu'
import axios from 'axios'
import DataList from '../Kelas/DataList';
import DataCreate from '../Kelas/DataCreate';
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'DbKelasMain',
    components: {
        DataList,
        DataCreate,
        SideMenu,
        Loading,
    },
    data() {
        return {
            input: {
                name: ""
            },
            result: "",
            errors: [],
            dataList: [{
                level: '',
                name: '',
                done: false,
            }],
            isLoading: false
        }
    },
    created() {
        this.getData()
        // console.log(this.$router.currentRoute.name)
        // this.currentRouteName = this.$router.currentRoute.name
    },
    beforeMount() {
        this.$emit("authenticated", true)
    },
    methods: {  
        goTutorial(){
            window.open("https://www.studentqr.com/resources", '_blank');
        },
        getHelp(){            
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        getData() {

            let self = this;
            this.isLoading = true;

            axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
            axios.defaults.responseType = 'json'
            axios.post(process.env.MY_URL + '/api/auth/kelas/list', {
                    params: {
                        email: localStorage.getItem('email'),
                        sessionID: localStorage.getItem('sessionID')
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    self.dataList = response.data
                    for (var i = 0; i < self.dataList.length; i++){
                        for (var j = 0; j < self.dataList[i].teachers.length; j++){
                            if (self.dataList[i].teachers[j] == null){
                                self.dataList[i].teachers.splice(j,1)
                            }
                        }
                    }
                    self.isLoading = false
                })
                .catch(e => {
                    this.errors.push(e)
                    self.isLoading = false
                    console.log(e)
                })
        },

    }
}
</script>



// WEBPACK FOOTER //
// src/components/Database/Kelas/Main.vue